const NewsLetterConfig = () => {
  const NewsLetterConfigData = {
    mailChimpApiKey: "6051dcd173371fad35b5f91d1ce47393-us8",
    title: "Join Our Newsletter",
    description:
      "Newslaundry wants to make news a service to the public, not to the advertisers. We believe those who make any effort sustainable, determine its direction.",
    hindiTitle: "हमारे न्यूज़लेटर से जुड़िए",
    hindiDescription:
      "न्यूज़लॉन्ड्री का प्रयास खबरों को विज्ञापनादाताओं के चंगुल से मुक्त करवा कर जनहित से जोड़ना है. हमें भरोसा है कि इस दिशा में सार्थक प्रयास करने वाला ही मीडिया की दिशा तय करेगा.",
    subscriptionData: [
      {
        title: "Stop Press",
        description:
          "A weekly newsletter by Chitranshu Tewari to help you track the news media ecosystem and make sense of it. See the latest edition here ",
        mailChimplistId: "a2ab56c30d",
        id: "first"
      },
      {
        title: "NL Events",
        description:
          "Newslaundry Events: From The Media Rumble to NL Chats and webinars, updates and details on latest Newslaundry events",
        mailChimplistId: "3cf030021e",
        id: "second"
      },
      {
        title: "NL Digest",
        description:
          "A weekly guide to the best of our stories from our editors and reporters. Note: Skip if you're a subscriber. All subscribers get a weekly, subscriber-only newsletter by default.",
        mailChimplistId: "c6b749d171",
        id: "third"
      },
      
      {
        title: "न्यूज़लॉन्ड्री डाक",
        description:
          "न्यूज़लॉन्ड्री हिन्दी के साप्ताहिक संपादकीय, चुनिंदा बेहतरीन रिपोर्ट्स, टिप्पणियां और मीडिया की स्वस्थ आलोचनाएं.",
        mailChimplistId: "aa2c780e6c",
        id: "fifth"
      },
      {
        title: "Mic Drop",
        description:
          "A weekly capsule of our podcasts, part of some of India's most-followed podcasts on media, politics, pop culture, food and more. ",
        mailChimplistId: "82e2052fcc",
        id: "sixth"
      }
    ]
  };

  return NewsLetterConfigData;
};

module.exports = NewsLetterConfig;
